import { render } from "./Reader.vue?vue&type=template&id=49be9283"
import script from "./Reader.vue?vue&type=script&lang=js"
export * from "./Reader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__